export default "__VITE_ASSET__DWEPPoNV__"